import { useMediaQuery } from "@material-ui/core";
import React from "react";

export const IsMobileContext = React.createContext(false);

const IsMobile: React.FC = ({ children }) => {
  const isMobile = useMediaQuery("(max-width:500px)");

  return (
    <IsMobileContext.Provider value={isMobile}>
      {children}
    </IsMobileContext.Provider>
  );
};

export default IsMobile as React.ComponentType;
